import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Tabs,
  Card,
  message,
  Table,
  Popconfirm,
  Modal,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { professionalAction } from "../../_actions";
import axios from "axios";
import moment from "moment";
import { DocumentVerificationAction } from "../../_actions/documentVerification.actions";
import { professionalService } from "../../_services";

const { TabPane } = Tabs;

export const CrimeDocumentVerification = (props) => {
  const [vehicleForm] = Form.useForm();
  const [dlForm] = Form.useForm();
  const [aadharForm] = Form.useForm();
  const [voterForm] = Form.useForm();
  const [passportForm] = Form.useForm();
  const [ipAddress, setIpAddress] = useState("");
  const [loading, setLoading] = useState(false);

  const [vehicleData, setVehicleData] = useState([]);
  const [dlData, setDlData] = useState([]);
  const [aadharData, setAadharData] = useState([]);
  const [voterData, setVoterData] = useState([]);
  const [passportData, setPassportData] = useState([]);
  const [basicName, setBasicName] = useState(null);
  const [address, setAddress] = useState(null);

  const getCriminalsById = (id) => {
    setBasicName();
    professionalService.getCriminalsById(id).then((res) => {
      setBasicName(res?.basicInfo[0]?.name);
      setAddress(res?.basicInfo[0]?.address);
    });
  };

  useEffect(() => {
    getCriminalsById(props?.masterId);
  }, [props?.masterId]);

  console.log("basic name", basicName);
  const getVehicleDetailsByMasterId = (id) => {
    const temp = {
      masterId: id ? "" : props?.masterId,
      id: id && id,
    };
    DocumentVerificationAction.getVehicleDetailsByMasterId(temp).then((res) => {
      console.log("res", res);
      setVehicleData(res.data);
    });
  };
  const getDrivingLicenseDetailsByMasterId = (id) => {
    const temp = {
      masterId: id ? "" : props?.masterId,
      id: id && id,
    };
    DocumentVerificationAction.getDrivingLicenseDetailsByMasterId(temp).then(
      (res) => {
        console.log("res", res);
        setDlData(res.data);
      }
    );
  };
  const getPassportDetailsByMasterId = (id) => {
    const temp = {
      masterId: id ? "" : props?.masterId,
      id: id && id,
    };
    DocumentVerificationAction.getPassportDetailsByMasterId(temp).then(
      (res) => {
        console.log("res", res);
        setPassportData(res.data);
      }
    );
  };
  const getAdhharBasicDetailsByMasterId = (id) => {
    const temp = {
      masterId: id ? "" : props?.masterId,
      id: id && id,
    };
    DocumentVerificationAction.getAdhharBasicDetailsByMasterId(temp).then(
      (res) => {
        console.log("res", res);
        setAadharData(res.data);
      }
    );
  };
  const getVoterDetailsByMasterId = (id) => {
    const temp = {
      masterId: id ? "" : props?.masterId,
      id: id && id,
    };
    DocumentVerificationAction.getVoterDetailsByMasterId(temp).then((res) => {
      console.log("res", res);
      setVoterData(res.data);
    });
  };

  useEffect(() => {
    if (props?.masterId) {
      getVehicleDetailsByMasterId();
      getDrivingLicenseDetailsByMasterId();
      getPassportDetailsByMasterId();
      getAdhharBasicDetailsByMasterId();
      getVoterDetailsByMasterId();
    }
  }, [props?.masterId]);

  const getData = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_GEOLOCATION_URL}/json/`
    );
    setIpAddress(res.data.IPv4);
  };

  useEffect(() => {
    getData();
  }, []);

  const handleMerge = async (type, id, merge) => {
    let temp = {
      masterId: props.masterId,
      id: id,
      is_merge: merge,
      type: type,
    };
    DocumentVerificationAction.mergeDocument(temp).then((res) => {
      message.success("Merge successfully");
      if (type === "vehicle") {
        getVehicleDetailsByMasterId(id);
      }
      if (type === "voter") {
        getVoterDetailsByMasterId(id);
      }
      if (type === "passport") {
        getPassportDetailsByMasterId(id);
      }
      if (type === "dl") {
        getDrivingLicenseDetailsByMasterId(id);
      }
      if (type === "aadhar") {
        getAdhharBasicDetailsByMasterId(id);
      }
    });
  };
  // Vehicle API
  const handleVehicleSubmit = async (values) => {
    console.log("this props", props);
    console.log("Vehicle Data:", values);

    const data = {
      id_number: values.vehicle_number,
    };
    setLoading(true);
    console.log("data", data);

    try {
      const thirdPartyResponse =
        await professionalAction.addVehicalDetailsThirdParty(data);
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate vehicle details with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = props?.user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = "गुन्ह्यातिल आरोपी";

      const requestData = thirdPartyData.data;

      Object.keys(requestData).forEach((key) => {
        if (requestData[key] === null) {
          requestData[key] = "";
        }
      });

      const mainServiceResponse = await professionalAction.addVehicalDetails(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to add vehicle details to the main service"
        );
      }

      message.success(`Submitted successfully`);
      vehicleForm.resetFields();
      console.log("mainServiceResponse.data", mainServiceResponse);
      const Data = await mainServiceResponse.json();
      console.log("data", Data);
      getVehicleDetailsByMasterId(Data?.message?.id);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Driving License API
  const handleDLSubmit = async (values) => {
    const drivingLicence = values.documentNumber;
    const dob = moment(values.dob).format("YYYY-MM-DD");

    const formattedData = {
      id_number: drivingLicence,
      dob: dob,
    };
    setLoading(true);

    try {
      const thirdPartyResponse =
        await professionalAction.addDrivinglicenceThirdParty(formattedData);
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Driving License with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = props?.user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = "गुन्ह्यातिल आरोपी";
      const requestData = thirdPartyData.data;

      const mainServiceResponse = await professionalAction.addDrivinglicence(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Driving License with the main service"
        );
      }

      message.success(`Submitted successfully`);
      const Data = await mainServiceResponse.json();
      console.log("data", Data);
      getDrivingLicenseDetailsByMasterId(Data?.message?.id);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Aadhar API
  const handleAadharSubmit = async (values) => {
    const data = {
      id_number: values.documentNumber,
    };
    setLoading(true);

    try {
      const thirdPartyResponse =
        await professionalAction.addAadharBasicThirdParty(data);
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message || "Failed to add Aadhar to third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();

      const requestData = thirdPartyData.data;
      thirdPartyData.data["user_id"] = props?.user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = "गुन्ह्यातिल आरोपी";

      const mainServiceResponse = await professionalAction.addAadharBasic(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message || "Failed to add Aadhar to the main service"
        );
      }

      message.success(`Submitted successfully`);
      const Data = await mainServiceResponse.json();
      console.log("data", Data);
      getAdhharBasicDetailsByMasterId(Data?.message?.id);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Voter API
  const handleVoterSubmit = async (values) => {
    const voterId = values.voter_id;

    const formattedData = {
      id_number: voterId,
    };
    setLoading(true);

    try {
      const thirdPartyResponse = await professionalAction.addVoterThirdParty(
        formattedData
      );
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Voter ID with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = props?.user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = "गुन्ह्यातिल आरोपी";

      const requestData = thirdPartyData.data;

      if (requestData.hasOwnProperty("id")) {
        delete requestData.id;
      }

      const mainServiceResponse = await professionalAction.addVoter(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Voter ID with the main service"
        );
      }

      message.success(`Submitted successfully`);
      const Data = await mainServiceResponse.json();
      console.log("data", Data);
      getVoterDetailsByMasterId(Data?.message?.id);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Passport API
  const handlePassportSubmit = async (values) => {
    const passport = values.documentNumber;
    const dob = moment(values.passport_dob).format("YYYY-MM-DD");

    const formattedData = {
      id_number: passport,
      dob: dob,
    };
    setLoading(true);

    try {
      const thirdPartyResponse = await professionalAction.addPassportThirdParty(
        formattedData
      );
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Passport with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = props?.user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = "गुन्ह्यातिल आरोपी";

      const requestData = thirdPartyData.data;

      const mainServiceResponse = await professionalAction.addPassport(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Passport with the main service"
        );
      }

      message.success(`Submitted successfully`);
      const Data = await mainServiceResponse.json();
      getPassportDetailsByMasterId(Data?.message?.id);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const showMergeConfirm = (type, record) => {
    let titleMap = {
      vehicle: "वाहन नोंद विलीन करा",
      dl: "लायसन्स नोंद विलीन करा",
      aadhar: "आधार नोंद विलीन करा",
      voter: "मतदार ओळखपत्र नोंद विलीन करा",
      passport: "पासपोर्ट नोंद विलीन करा",
    };

    // 🔥 Type-wise Marathi content
    const getContent = () => {
      switch (type) {
        case "vehicle":
          return (
            <div>
              <p>
                <b>वाहन क्रमांक :</b> {record?.rc_number}
              </p>
              <p>
                <b>Id :</b> {props?.masterId}
              </p>
              <p>
                <b>आरोपीचे नाव :</b> {basicName}
              </p>
              <p>ही नोंद आरोपीसोबत जोडायची आहे का?</p>
            </div>
          );

        case "dl":
          return (
            <div>
              <p>
                <b>लायसेन्स नंबर :</b> {record?.license_number}
              </p>
              <p>
                <b>Id :</b> {props?.masterId}
              </p>
              <p>
                <b>आरोपीचे नाव :</b> {basicName}
              </p>
              <p>ही नोंद आरोपीसोबत जोडायची आहे का?</p>
            </div>
          );

        case "aadhar":
          return (
            <div>
              <p>
                <b>आधार नंबर :</b> {record?.aadhaar_number}
              </p>
              <p>
                <b>Id :</b> {props?.masterId}
              </p>
              <p>
                <b>आरोपीचे नाव :</b> {basicName}
              </p>
              <p>ही नोंद आरोपीसोबत जोडायची आहे का?</p>
            </div>
          );

        case "voter":
          return (
            <div>
              <p>
                <b>मतदार ओळखपत्र नंबर :</b> {record?.epic_no}
              </p>
              <p>
                <b>Id :</b> {props?.masterId}
              </p>
              <p>
                <b>आरोपीचे नाव :</b> {basicName}
              </p>
              <p>ही नोंद आरोपीसोबत जोडायची आहे का?</p>
            </div>
          );

        case "passport":
          return (
            <div>
              <p>
                <b>पासपोर्ट नंबर :</b> {record?.file_number}
              </p>
              <p>
                <b>Id :</b> {props?.masterId}
              </p>
              <p>
                <b>आरोपीचे नाव :</b> {basicName}
              </p>
              <p>ही नोंद आरोपीसोबत जोडायची आहे का?</p>
            </div>
          );

        default:
          return <p>ही नोंद जोडायची आहे का?</p>;
      }
    };

    Modal.confirm({
      title: titleMap[type] || "नोंद विलीन करा",
      content: getContent(),
      okText: "होय, विलीन करा",
      cancelText: "रद्द करा",
      centered: true,
      onOk() {
        handleMerge(type, record.id, true);
      },
      onCancel() {
        message.info("Merge cancelled");
      },
    });
  };

  const CommonTable = ({ data, type }) => {
    const getColumns = () => {
      switch (type) {
        case "vehicle":
          return [
            {
              title: "Sr.No",
              render: (text, record, index) => index + 1,
            },
            {
              title: "Rc Number",
              dataIndex: "rc_number",
            },
            {
              title: "Full Name",
              dataIndex: "owner_name",
            },
            {
              title: "Insurance Upto",
              dataIndex: "insurance_upto",
              key: "insurance_upto",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Fit Upto",
              dataIndex: "fit_up_to",
              key: "fit_up_to",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Make Model",
              dataIndex: "maker_model",
              key: "maker_model",
            },
            {
              title: "Searched At",
              dataIndex: "createdAt",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },

            {
              title: "Action",
              key: "action",
              render: (text, record) =>
                record?.is_merge ? (
                  "-"
                ) : (
                  <Button
                    type="primary"
                    onClick={() => showMergeConfirm("vehicle", record)}
                  >
                    Merge
                  </Button>
                ),
            },
          ];

        case "dl":
          return [
            {
              title: "Sr.No",
              render: (text, record, index) => index + 1,
            },
            {
              title: "Licence Number",
              dataIndex: "license_number",
              key: "license_number",
            },
            {
              title: "Full Name",
              dataIndex: "name",
              key: "name",
              render: (text) => <span className="blinking-text">{text}</span>,
            },
            {
              title: "DOB",
              dataIndex: "dob",
              key: "dob",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Searched At",
              dataIndex: "createdAt",
              key: "createdAt",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Action",
              key: "action",
              render: (record) =>
                record?.is_merge ? (
                  "-"
                ) : (
                  <>
                    <Button
                      type="primary"
                      onClick={() => showMergeConfirm("dl", record)}
                    >
                      Merge
                    </Button>
                  </>
                ),
            },
          ];

        case "aadhar":
          return [
            {
              title: "Sr.No",
              render: (text, record, index) => index + 1,
            },
            {
              title: "Aadhar Number",
              dataIndex: "aadhaar_number",
              key: "aadhaar_number",
            },
            {
              title: "Gender",
              dataIndex: "gender",
              key: "gender",
              render: (text) =>
                text === "F" ? "Female" : text === "M" ? "Male" : "Unknown",
            },
            { title: "Age Range", dataIndex: "age_range", key: "age_range" },
            { title: "State", dataIndex: "state", key: "state" },
            {
              title: "Last 3 digit",
              dataIndex: "last_digits",
              key: "last_digits",
            },
            {
              title: " Searched At",
              dataIndex: "createdAt",
              key: "createdAt",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Action",
              key: "action",
              render: (record) =>
                record?.is_merge ? (
                  "-"
                ) : (
                  <>
                    <Button
                      type="primary"
                      onClick={() => showMergeConfirm("aadhar", record)}
                    >
                      Merge
                    </Button>
                  </>
                ),
            },
          ];

        case "voter":
          return [
            {
              title: "Sr.No",
              render: (text, record, index) => index + 1,
            },
            {
              title: "Voter Id",
              dataIndex: "epic_no",
              key: "epic_no",
            },
            {
              title: "Name",
              dataIndex: "name",
              key: "name",
            },
            {
              title: "DOB",
              dataIndex: "dob",
              key: "dob",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Assembly Constituency",
              dataIndex: "assembly_constituency",
              key: "assembly_constituency",
            },
            {
              title: "Parliamentary Constituency",
              dataIndex: "parliamentary_constituency",
              key: "parliamentary_constituency",
            },
            {
              title: "Searched At",
              dataIndex: "createdAt",
              key: "createdAt",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Action",
              key: "action",
              render: (record) =>
                record?.is_merge ? (
                  "-"
                ) : (
                  <>
                    <Button
                      type="primary"
                      onClick={() => showMergeConfirm("voter", record)}
                    >
                      Merge
                    </Button>
                  </>
                ),
            },
          ];

        case "passport":
          return [
            {
              title: "Sr.No",
              render: (text, record, index) => index + 1,
            },
            {
              title: "File Number",
              dataIndex: "file_number",
              key: "file_number",
            },
            {
              title: "Name",
              dataIndex: "full_name",
              key: "full_name",
            },
            {
              title: "DOB",
              dataIndex: "dob",
              key: "dob",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Passport Number",
              dataIndex: "passport_number",
              key: "passport_number",
            },
            {
              title: "Date of Application",
              dataIndex: "date_of_application",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: " Searched At",
              dataIndex: "createdAt",
              key: "createdAt",
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: "Action",
              key: "action",
              render: (record) =>
                record?.is_merge ? (
                  "-"
                ) : (
                  <>
                    <Button
                      type="primary"
                      onClick={() => showMergeConfirm("passport", record)}
                    >
                      Merge
                    </Button>
                  </>
                ),
            },
          ];

        default:
          return [];
      }
    };

    return (
      <Table
        columns={getColumns()}
        dataSource={data}
        rowKey="id"
        scroll={{ x: "100%" }}
      />
    );
  };
  const [activeTab, setActiveTab] = useState("1");
  useEffect(() => {
    if (props?.masterId) {
      setActiveTab("1");
    }
  }, [props?.masterId]);
  return (
    <Card bordered={false}>
      <Typography.Title level={5}>ID {props?.masterId}</Typography.Title>
      <Typography.Title level={5}>आरोपीचे नाव: {basicName}</Typography.Title>
      <Typography.Title level={5}>आरोपीचे पत्ता: {address}</Typography.Title>

      <Tabs
        centered
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
      >
        {/* Vehicle */}
        <TabPane tab="Vehicle" key="1">
          {vehicleData.length > 0 ? (
            <CommonTable data={vehicleData} type="vehicle" />
          ) : (
            <>
              <Form
                form={vehicleForm}
                layout="vertical"
                onFinish={handleVehicleSubmit}
              >
                <Form.Item
                  label="Vehicle Number"
                  name="vehicle_number"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Enter Vehicle Number" size="large" />
                </Form.Item>

                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  loading={loading}
                >
                  Find
                </Button>
              </Form>
            </>
          )}
        </TabPane>

        {/* Driving License */}
        <TabPane tab="Driving License" key="2">
          {dlData.length > 0 ? (
            <CommonTable data={dlData} type="dl" />
          ) : (
            <Form form={dlForm} layout="vertical" onFinish={handleDLSubmit}>
              <Form.Item
                label="Driving License Number"
                name="documentNumber"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter DL Number" size="large" />
              </Form.Item>

              <Form.Item
                label="Date of Birth"
                name="dob"
                rules={[{ required: true }]}
              >
                <DatePicker style={{ width: "100%" }} size="large" />
              </Form.Item>

              <Button type="primary" htmlType="submit" block size="large">
                Find
              </Button>
            </Form>
          )}
        </TabPane>

        {/* Aadhar */}
        <TabPane tab="Aadhar" key="3">
          {aadharData.length > 0 ? (
            <CommonTable data={aadharData} type="aadhar" />
          ) : (
            <Form
              form={aadharForm}
              layout="vertical"
              onFinish={handleAadharSubmit}
            >
              <Form.Item
                label="Aadhar Number"
                name="documentNumber"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Aadhar Number" size="large" />
              </Form.Item>

              <Button type="primary" htmlType="submit" block size="large">
                Find
              </Button>
            </Form>
          )}
        </TabPane>

        {/* Voter */}
        <TabPane tab="Voter ID" key="4">
          {voterData.length > 0 ? (
            <CommonTable data={voterData} type="voter" />
          ) : (
            <Form
              form={voterForm}
              layout="vertical"
              onFinish={handleVoterSubmit}
            >
              <Form.Item
                label="Voter ID"
                name="voter_id"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Voter ID" size="large" />
              </Form.Item>

              <Button type="primary" htmlType="submit" block size="large">
                Find
              </Button>
            </Form>
          )}
        </TabPane>

        {/* Passport */}
        <TabPane tab="Passport" key="5">
          {passportData.length > 0 ? (
            <CommonTable data={passportData} type="passport" />
          ) : (
            <Form
              form={passportForm}
              layout="vertical"
              onFinish={handlePassportSubmit}
            >
              <Form.Item
                label="Passport Number"
                name="documentNumber"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Passport Number" size="large" />
              </Form.Item>

              <Form.Item
                label="Date of Birth"
                name="passport_dob"
                rules={[{ required: true }]}
              >
                <DatePicker style={{ width: "100%" }} size="large" />
              </Form.Item>

              <Button type="primary" htmlType="submit" block size="large">
                Find
              </Button>
            </Form>
          )}
        </TabPane>
      </Tabs>
    </Card>
  );
};
